import { createAsyncThunk } from "@reduxjs/toolkit";
import { VolumeEngineService } from "../../services/VolumeEngineService";
import { AxiosError } from "axios";
import {
  CalculateRatioThunkPayload,
  CalculateRatioThunkResponse,
} from "../../entities/VolumeEngine";

export const getCalculatedRatioForCondiments = createAsyncThunk<
  CalculateRatioThunkResponse,
  CalculateRatioThunkPayload,
  { rejectValue: AxiosError }
>(
  "volume-engine/getCalculatedRatio",
  async (
    { data, nextMixtureOption }: CalculateRatioThunkPayload,
    { rejectWithValue },
  ) => {
    try {
      const response = await VolumeEngineService.getCalculatedRatioOfCondiments(data);
      return { condiments: response, nextMixtureOption };
    } catch (e: any) {
      return rejectWithValue(e.message as AxiosError);
    }
  },
);
